// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import React from 'react';
import { Button } from './Button';
import { TextBox } from '../../elements/TextBox';
export class LookUp extends WMComponent {
    constructor(props, viewModel) {
        super(props, viewModel);
        this.onTextBoxChange = this.onTextBoxChange.bind(this);
        this.onTextBoxKeyDown = this.onTextBoxKeyDown.bind(this);
        this.onTextBoxWheel = this.onTextBoxWheel.bind(this);
        this.onSubscribeSelectAllInTextBox = this.onSubscribeSelectAllInTextBox.bind(this);
        this.onUnsubscribeSelectAllInTextBox = this.onUnsubscribeSelectAllInTextBox.bind(this);
        this.onLookupBtnClick = this.onLookupBtnClick.bind(this);
        this.onTextBoxFocus = this.onTextBoxFocus.bind(this);
        this.onTextBoxBlur = this.onTextBoxBlur.bind(this);
        this.btnClass = 'js-lookup-show';
        this.cssClass = 'js-tercera-lookup';
        this.mainContainerRef = React.createRef();
    }
    onTextBoxChange(value) {
        this.viewModel.onTextChange(value);
    }
    onTextBoxKeyDown(event) {
        this.viewModel.onKeyDown(event);
    }
    onTextBoxWheel(event) {
        this.viewModel.onMouseWheel(event);
    }
    onSubscribeSelectAllInTextBox(callback) {
        this.viewModel.onSubscribeSelectAllInTextBox(callback);
    }
    onUnsubscribeSelectAllInTextBox(callback) {
        this.viewModel.onUnsubscribeSelectAllInTextBox(callback);
    }
    onLookupBtnClick() {
        this.viewModel.showDropDowmForm(this.mainContainerRef.current);
    }
    onTextBoxFocus(event) {
        this.viewModel.showAutoCompleteQuickTable(this.mainContainerRef.current);
    }
    onTextBoxBlur(event) {
        this.viewModel.hideAutoCompleteTable();
    }
    render() {
        const { haveError, btnTooltip } = this.state;
        const { enabled, isTextBoxVisible, btnImage } = this.props;
        return (React.createElement("div", { className: `${this.cssClass} ${haveError ? 'js-tercera-lookup-error' : ''}`, ref: this.mainContainerRef },
            isTextBoxVisible && this.renderTextBox(),
            React.createElement(Button, { buttonStyle: this.btnClass, enabled: enabled, tooltip: btnTooltip, onClick: this.onLookupBtnClick, image: btnImage })));
    }
    renderTextBox() {
        const { enabled, isReadOnly } = this.props;
        const { textBoxValue } = this.state;
        return (React.createElement(TextBox, { enabled: enabled, isReadOnly: isReadOnly, text: textBoxValue, onChange: this.onTextBoxChange, onKeyDown: this.onTextBoxKeyDown, onWheel: this.onTextBoxWheel, onSubscribeSelectAllInTextBox: this.onSubscribeSelectAllInTextBox, onUnsubscribeSelectAllInTextBox: this.onUnsubscribeSelectAllInTextBox, onFocus: this.onTextBoxFocus, onBlur: this.onTextBoxBlur }));
    }
}
LookUp.defaultProps = {
    enabled: true,
    isTextBoxVisible: true,
    isReadOnly: false,
    btnImage: null
};
